import { getFluxBotToken } from "@/shared";
import { useSettingsStore } from "@/pinia";
import fetchWithAuth from "@/plugins/fetch";

export async function fetchFluxBotAction(
	wallet: string,
	action: string,
	payload?: any
): Promise<any> {
	const webSettings = useSettingsStore().settings;

	const res = await fetchWithAuth("https://gateway.fluxbeam.xyz/bot/actions", {
		method: "POST",
		body: JSON.stringify({
			wallet: wallet,
			action: action,
			payload: payload,
			settings: {
				slippage: webSettings.slippage,
				platforms: 503,
				mevProtect: webSettings.validatorTip !== null || webSettings.validatorTip != 0,
				validatorTip: 					webSettings.validatorTip === null
					? webSettings.validatorLevel
					: `${webSettings.validatorTip}`,
				priorityFee:
					webSettings.priorityFeeMax === null
						? webSettings.priorityLevel
						: `${webSettings.priorityFeeMax}`,
			},
		}),
		headers: {
			"Content-Type": "application/json",
			Authorization: getFluxBotToken(wallet),
		},
	});

	const j = await res.json();

	if (!res.ok) {
		throw new Error(j?.error || res.statusText);
	}

	return j;
}
